import React from 'react';
import section3Image from '../assets/images/section3.png';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './AdvantageSection.css';

const AdvantageSection = () => {
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.6);
  const [titleRef, isTitleVisible] = useScrollAnimation(0.7);
  const [textRef, isTextVisible] = useScrollAnimation(0.8);
  const [imageRef, isImageVisible] = useScrollAnimation(0.9);

  return (
    <section ref={sectionRef} className="advantage-section">
      <div className="advantage-container">
        <div className="advantage-text-row">
          <div ref={titleRef} className={`advantage-text-left ${isTitleVisible ? 'visible' : ''}`}>
            <h2 className={`advantage-title text-reveal ${isTitleVisible ? 'visible' : ''}`}>THE INDUS ADVANTAGE</h2>
          </div>
          <div ref={textRef} className={`advantage-text-right ${isTextVisible ? 'visible' : ''}`}>
            <p className={`advantage-description text-reveal stagger-1 ${isTextVisible ? 'visible' : ''}`}>
              We have felt a serious need among importers for some reliable source of Indian furniture who closely understands western customer's behaviour in regard to his furniture selection. One who really respects western principles of buying and selling including necessity of time bound delivery of consistent quality, and knows the costs involved even in minor repairs and value one has to pay for unfulfilled commitments. Finally one who really means what he says. Our concept of business has been built around this feedback.
            </p>
          </div>
        </div>
        
        <div ref={imageRef} className={`advantage-image-container ${isImageVisible ? 'visible' : ''}`}>
          <img src={section3Image} alt="The Indus Advantage" className={`advantage-image image-reveal ${isImageVisible ? 'visible' : ''}`} />
        </div>
      </div>
    </section>
  );
};

export default AdvantageSection;
